export default __webpack_public_path__ + "static/media/access-denied.0707ee91.png";